<template>
  <div class="container-img-info">

    <div class="img-info">
      <img
        :src="require('../../assets/background/wait.svg')"
        alt="wait for your link"
      >
      <span>Wait a moment, creating link</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal-wait',
};
</script>
<style lang="scss">
.container-img-info {
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(48, 48, 48, 0.5);
  .img-info {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    background-color: $white;
    width: 44.2vw;
    height: 69.5vh;
    border-radius: 10px;
    img {
      animation-name: updown;
      animation-duration: 1s;
      animation-iteration-count: infinite;
      animation-direction: alternate;
      transition: ease-in-out;
    }
    @media (max-width: 960px) {
      width: 100%;
      height: 100%;
      border-radius: 0px;
    }
    span {
      font-weight: 500;
      font-size: 24px;
      letter-spacing: 0.274837px;
      color: $black;
    }
  }
}
@keyframes updown {
  from {
    transform: translateY(10px);
  }
  to {
    transform: translateY(0px);
  }
}
</style>
